export var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["ERROR"] = 0] = "ERROR";
    LoadingState[LoadingState["LOADING"] = 1] = "LOADING";
    LoadingState[LoadingState["SUCCESS"] = 2] = "SUCCESS";
    LoadingState[LoadingState["NONE"] = 3] = "NONE";
})(LoadingState || (LoadingState = {}));
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["sm"] = "SMALL";
    Breakpoint["md"] = "MEDIUM";
    Breakpoint["lg"] = "LARGE";
})(Breakpoint || (Breakpoint = {}));
